(function ($) {
  "use strict";

  function isShowcaseMobile() {
    return window.matchMedia("(max-width: 991px)").matches;
  }

  function prepareShowcaseCarousel($carousel) {
    if (!$carousel || !$carousel.length) {
      return;
    }
    var $slide = $carousel.data("showcaseVitrinSlide");
    if (!$slide || !$slide.length) {
      $slide = $carousel.children(".showcase-collection__vitrin-slide").first();
    }
    if (!$slide.length) {
      return;
    }

    if (isShowcaseMobile()) {
      if (!$slide.parent().is($carousel)) {
        $slide.prependTo($carousel);
      }
      $carousel.removeData("showcaseVitrinSlide");
    } else if ($slide.parent().is($carousel)) {
      $carousel.data("showcaseVitrinSlide", $slide.detach());
    }
  }

  function prepareAllShowcaseCarousels($context) {
    var $root = $context && $context.length ? $context : $(".wpbingo-section--showcase-collection");
    $root.find(".showcase-collection__slick.js-carousel").each(function () {
      prepareShowcaseCarousel($(this));
    });
  }

  function patchSlickInit() {
    if (!window.wpbingo || wpbingo._showcaseCollectionPatched) {
      return;
    }
    wpbingo._showcaseCollectionPatched = true;

    var slickCarouselElement = wpbingo.slickCarouselElement;
    if (typeof slickCarouselElement === "function") {
      wpbingo.slickCarouselElement = function ($element) {
        if ($element.closest(".wpbingo-section--showcase-collection").length) {
          prepareShowcaseCarousel($element);
        }
        return slickCarouselElement.call(wpbingo, $element);
      };
    }

    var refreshTabPaneCarousels = wpbingo.refreshTabPaneCarousels;
    if (typeof refreshTabPaneCarousels === "function") {
      wpbingo.refreshTabPaneCarousels = function ($tabPane, forceReinit) {
        prepareAllShowcaseCarousels($tabPane);
        return refreshTabPaneCarousels.call(wpbingo, $tabPane, forceReinit);
      };
    }
  }

  function reinitVisibleShowcaseCarousels($context) {
    prepareAllShowcaseCarousels($context);
    var $root = $context && $context.length ? $context : $(document);
    $root.find(".wpbingo-section--showcase-collection .showcase-collection__slick.js-carousel").each(function () {
      var $carousel = $(this);
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
        $carousel.parent().find(".slick-prev, .slick-next").remove();
      }
      if (typeof wpbingo !== "undefined" && wpbingo.slickCarouselElement) {
        wpbingo.slickCarouselElement($carousel);
      }
    });
  }

  function findShowcaseCarousel($trigger) {
    var $carousel = $trigger.closest(".showcase-collection__slick.js-carousel");
    if (!$carousel.length) {
      $carousel = $trigger
        .closest(".showcase-collection__vitrin-slide")
        .closest(".showcase-collection__slick.js-carousel");
    }
    if (!$carousel.length) {
      $carousel = $trigger
        .closest(".showcase-collection__products")
        .find(".showcase-collection__slick.js-carousel.slick-initialized")
        .first();
    }
    return $carousel;
  }

  patchSlickInit();

  var resizeTimer;
  $(window).on("resize.showcaseCollection", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      reinitVisibleShowcaseCarousels();
    }, 250);
  });

  $(document).on("click", "[data-showcase-vitrin-next]", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!isShowcaseMobile()) {
      return;
    }
    var $carousel = findShowcaseCarousel($(this));
    if ($carousel.length && $carousel.hasClass("slick-initialized")) {
      $carousel.slick("slickNext");
    }
  });

  $(function () {
    patchSlickInit();
    prepareAllShowcaseCarousels();
  });

  document.addEventListener("shopify:section:load", function (event) {
    var $section = $("#shopify-section-" + event.detail.sectionId);
    if ($section.find(".wpbingo-section--showcase-collection").length) {
      patchSlickInit();
      setTimeout(function () {
        reinitVisibleShowcaseCarousels($section);
      }, 100);
    }
  });
})(jQuery);
